module.exports = __webpack_public_path__ + "static/img/index-t4.3aa74f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appimg/index/pic/index-t4.jpg
// module id = O/bX
// module chunks = 11